import React from 'react';
import {Form,Input,Button,Checkbox,message,Spin,Switch,Select,DatePicker,Card,Result} from 'antd';
import axios from 'axios';
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined } from '@ant-design/icons';
import * as serverconfig from '../serverconn'
import PhoneInput from 'react-phone-number-input'

var CryptoJS = require("crypto-js");

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var token= ''
var sacco= ''
const dateFormat = 'DD/MM/YYYY';

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;
const { Option } = Select;

class  MemberPortalUserCreationForm extends React.Component {

  state = {
    isactive:false,
    ismanager:false,
    profile_pic:null,  
    datarequested:false,
    saccopackageobj:{},

    username:'',
    email:'',
    password1:'',
    password2:'',


    sur_name:'',
    other_name:'',
    nationality:'',
    date_Of_Birth:'',
    Area_Of_Residence:'',
    gender:'',
    RegisteredPhoneNumber1:'',
    members:[],
    selectedaccountobject:{},
    selectedaccount:'',
    message:'',
    datasubmittedsuccessfully:false,



  }


  formRef = React.createRef();

  componentDidMount() {

    if(localStorage.getItem("sacco")){
      sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
   }else{
      sacco= ''
   }
   
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
        this.setState({
          members:res.data
        })
    })
   


  }



  handleprofile_picChange= (e) => this.setState({ profile_pic: e.target.files[0]});


    // on form submit heree
    onFinish = values => {

      if (this.state.selectedaccountobject.AccountNumber==="null" || this.state.selectedaccountobject.AccountNumber==="" || this.state.selectedaccountobject.AccountNumber===null){
        message.error("Username is empty")
      }else if (this.state.selectedaccountobject.EmailAddress==="null" || this.state.selectedaccountobject.EmailAddress==="" || this.state.selectedaccountobject.EmailAddress===null){
        message.error("Email is empty")

      }else{

        this.setState({datarequested:true})

        let form_data = new FormData();
        form_data.append('username', this.state.selectedaccountobject.AccountNumber);
        form_data.append('email', this.state.selectedaccountobject.EmailAddress);
        form_data.append('password1', this.state.password1);
        form_data.append('password2', this.state.password2);
        form_data.append('is_active', true);
        form_data.append('branch_manager', false);
        form_data.append('sacco', sacco);

        form_data.append('member_id', this.state.selectedaccountobject.id);

        //Register the account first
        axios.post(serverconfig.backendserverurl+'/customqueries/createsystem_user',form_data)
        .then(res =>{
          this.setState({datarequested:false})
         this.setState({message:res.data.message})
          this.setState({datasubmittedsuccessfully:true})

        })
      .catch(error => console.log(error))
      }


    };


  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin  size="large">
                <div className="content" />
              </Spin>  
       </div>
      )

    }else{

      if (this.state.datasubmittedsuccessfully===true){
        return(
            <Card>
            <Result
            status="success"
            title="Request status"
            subTitle={this.state.message}
            extra={[
              <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
            ]}
            />

            </Card>
         
        );

      }else{

        return (

          <div>
            <h3>Create new member portal user account here</h3>
          <Form
            name="register"
            onFinish={this.onFinish}
          >

          <FormItem label="Member Account">
              <Select 
              placeholder="Account No | Name" 
              style={{  }} 
              value={this.state.selectedaccount}
              onChange={
                (e) =>{
                  this.setState({ selectedaccount: e});
                  //make query for last transactions
                  axios.get(`${serverconfig.backendserverurl}/api/members/${e}`)
                    .then(res => {  
                        this.setState({selectedaccountobject: res.data})
                  })

                }

              } 
              showSearch
              optionFilterProp="children"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onSearch={this.onSearch}
                                    
              >
                {this.state.members.map(
                  (accnt)=>(
                    <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                  ))}
              </Select>
          </FormItem>
  
          <h3>Username: {this.state.selectedaccountobject.AccountNumber} | Email: {this.state.selectedaccountobject.EmailAddress}</h3>
         
            <Form.Item
              name="password"
              label="Password"
              rules={[
                {
                  required: true,
                  message: 'Please input your password!',
                },
              ]}
              hasFeedback
            >
              <Input.Password 
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
              value={this.state.password1}
              onChange={(val)=>{this.setState({password1:val.target.value})}}
              />
  
  
            </Form.Item>
  
      
            <Form.Item
              name="confirm"
              label="Confirm Password"
              dependencies={['password']}
              hasFeedback
              rules={[
                {
                  required: true,
                  message: 'Please confirm your password!',
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || getFieldValue('password') === value) {
                      return Promise.resolve();
                    }
      
                    return Promise.reject('The two passwords that you entered do not match!');
                  },
                }),
              ]}
            >
              <Input.Password 
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password" 
              value={this.state.password2}
              onChange={(val)=>{this.setState({password2:val.target.value})}}
              />
  
            </Form.Item>
  
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Create Account
              </Button>
            </Form.Item>
            
          </Form>

          </div>
        );

     }

    }

  }

}


export default MemberPortalUserCreationForm;


